<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
    </div>
    <div class="theory">
      <div v-if="Funsuffix($route.query.path) == 1">
        <video
          style="width:100%;height:500px"
          :src="$route.query.path"
          controls="controls"
        ></video>
      </div>
      <div v-if="Funsuffix($route.query.path) == 2">
        <video
          style="width:100%;height:100px"
          :src="$route.query.path"
          controls="controls"
        ></video>
      </div>
      <div v-if="Funsuffix($route.query.path) == 3">
        <img
          style="max-width:750px"
          :src="$route.query.path"
          alt=""
        >
      </div>
      <div v-if="Funsuffix($route.query.path) == 4">
        <div class="pdf-region">
          <pdf
            :page="pageNum"
            :src="$route.query.path"
            @progress="loadedRatio = $event"
            @num-pages="pageTotalNum=$event"
          ></pdf>
        </div>
        <div class="pagecolor">
          <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
        </div>
      </div>
      <div v-show="Funsuffix($route.query.path) == 5">
        <div
          ref="file"
          class="my-docx"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import pdf from 'vue-pdf'
const docx = require('docx-preview')
export default {
  name: 'ViewFile',
  components: {
    HeaderInfo,
    pdf
  },
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0
    }
  },
  mounted() {

  },
  computed: {

  },

  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    Funsuffix(path) {
      if (path) {
        var first = path.lastIndexOf('.')
        var namelength = path.length
        var filesuffix = path.substring(first + 1, namelength).toLowerCase()
        var index = 0

        if (filesuffix === 'mp4') {
          index = 1
        } else if (filesuffix === 'mp3') {
          index = 2
        } else if (filesuffix === 'jpg' || filesuffix === 'png') {
          index = 3
        } else if (filesuffix === 'pdf') {
          index = 4
        } else if (filesuffix === 'doc' || filesuffix === 'docx') {
          index = 5
          this.$http.get(this.$store.state.api + this.$route.query.path, {
            responseType: 'blob',
            baseURL: ''
          }).then((data) => {
            docx.renderAsync(data, this.$refs.file)
          })
        }
      }
      return index
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
}
.pagecolor {
  text-align: center;
}
section.docx {
  width: 100% !important;
  padding: 5px !important;
}
section.docx div {
  width: 100% !important;
  height: auto !important;
}
section.docx p {
  margin: 0 !important;
}
section.docx img {
  width: 100% !important;
  height: auto !important;
  margin: 10px !important;
}
.docx-wrapper {
  padding: 10px !important;
}
</style>
